import { create } from 'apisauce';

import api, { apiSetup } from '~config/api';

const getSettings = () => api.get('v1/settings');
const getTenant = () => {
  const temporalApi = create({
    baseURL: window.location.origin
  });
  apiSetup(temporalApi);
  return temporalApi.get('/');
};

export default { getSettings, getTenant };
